import { Routes } from '@angular/router';
import { UserWalletComponent } from '@customers/user-profile/user-wallet/user-wallet.component';
import { AnonymousGuardCustomerService } from '@reusable/services/auth/AnonymousGuard.service';
import { AuthService } from '@reusable/services/auth/auth.service';
import { MobileLoginComponent } from '@reusable/shared/mobile-login/mobile-login.component';
import { StoreNewRequestComponent } from '@reusable/shared/new-request/new-request.component';
import { CustomersHomeComponent } from './customers-home/customers-home.component';
import { MyCarsFormComponent } from './my-cars-form/my-cars-form.component';
import { MyCarsComponent } from './my-cars/my-cars.component';
import { NotifcationsComponent } from './notifications/notifcations/notifcations.component';

export const customersRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [AnonymousGuardCustomerService],
    component: MobileLoginComponent
  },
  {
    path: 'home',
    component: CustomersHomeComponent,
    canActivate: [AuthService],
    children: [
      {
        path: '',
        redirectTo: 'requests',
        pathMatch: 'full'
      },
      {
        path: 'requests',
        loadChildren: () => import('./requests/requests.module').then(m => m.CustomersRequestsModule),
        canActivate: [AuthService]
      },
      {
        path: 'orders',
        loadChildren: () => import('./orders/orders.module').then(m => m.OrdersCustomerModule),
        canActivate: [AuthService]
      },
      {
        path: 'profile',
        loadChildren: () => import('./user-profile/user-profile.module').then(m => m.UserProfileModule),
        canActivate: [AuthService]
      },
      {
        path: 'notifications',
        component: NotifcationsComponent,
        canActivate: [AuthService]
      },
      {
        path: 'new-request',
        component: StoreNewRequestComponent,
        canActivate: [AuthService]
      },
      {
        path: 'my-cars',
        component: MyCarsComponent,
        canActivate: [AuthService]
      },
      {
        path: 'my-cars/new',
        component: MyCarsFormComponent,
        canActivate: [AuthService]
      },
      {
        path: 'my-cars/update/:id',
        component: MyCarsFormComponent,
        canActivate: [AuthService]
      },
      {
        path: 'wallet',
        component: UserWalletComponent
      },
      {
        path: 'car-services',
        loadChildren: () => import('./car-services/car-services.module').then(m => m.CarServicesModule),
        canActivate: [AuthService]
      }
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];